// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/CommentCitationLinks.test.tsx

/**
 * Chrome shared by every citation chip in this folder.
 *
 * The variants used to carry six byte-identical copies of this string inside
 * one file; once they became separate modules a copy per file would drift the
 * first time one of them was restyled. Extracted so the chips stay one visual
 * family.
 */
export const CITATION_CHIP_CLASS =
  "inline-flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-puntt-accent-11 underline underline-offset-2 hover:bg-transparent hover:text-puntt-accent-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-puntt-accent-9";

/**
 * The scroll box the chip dialogs open into. Deliberately NOT shared with
 * `KnowledgeRuleCitationDialog`, which is taller (`max-h-[85vh]`) because it
 * renders a full rule body rather than a single excerpt.
 */
export const CITATION_DIALOG_CONTENT_CLASS =
  "flex max-h-[min(70vh,420px)] flex-col gap-4 overflow-y-auto";
